import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { DiamondStatus } from '@sorare/core/src/components/missions/DiamondStatus';

import type { ClaimedTask_taskInterface } from './__generated__/index.graphql';

const Root = styled(Horizontal)`
  padding: var(--intermediate-unit);
  border-radius: var(--double-unit);
  border: 1px solid var(--c-nd-150);
  background: var(--c-black);
`;
const Content = styled.div`
  flex: 1;
`;

type Props = {
  claimedTask: ClaimedTask_taskInterface;
  className?: string;
};

export const ClaimedTask = ({ claimedTask, className }: Props) => {
  return (
    <Root className={className}>
      <DiamondStatus color="var(--c-nd-900)" status="checked" />
      <Content>
        <LabelL bold>{claimedTask.title}</LabelL>
      </Content>
    </Root>
  );
};

ClaimedTask.fragments = {
  taskInterface: gql`
    fragment ClaimedTask_taskInterface on TaskInterface {
      id
      title
    }
  ` as TypedDocumentNode<ClaimedTask_taskInterface>,
};
